import React from 'react';
import { UsersIcon, BookOpenIcon, StarIcon, MapPinIcon } from 'lucide-react';
export function SocialProofBar() {
  return <section className="bg-brand-navy text-white py-6 px-4" data-id="element-257">
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 text-center" data-id="element-258">
        <div className="flex flex-col items-center justify-center" data-id="element-259">
          <UsersIcon className="w-10 h-10 text-brand-primary mb-3" data-id="element-260" />
          <span className="text-3xl font-black mb-1" data-id="element-261">+1.500</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-262">
            personas
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-263">
          <BookOpenIcon className="w-10 h-10 text-brand-primary mb-3" data-id="element-264" />
          <span className="text-3xl font-black mb-1" data-id="element-265">5</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-266">
            Módulos Maestros
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-267">
          <div className="flex text-brand-amber mb-3" data-id="element-268">
            <StarIcon className="w-8 h-8 fill-current" data-id="element-269" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-270" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-271" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-272" />
            <StarIcon className="w-8 h-8 fill-current" data-id="element-273" />
          </div>
          <span className="text-3xl font-black mb-1" data-id="element-274">4.9/5</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-275">
            calificación
          </span>
        </div>
        <div className="flex flex-col items-center justify-center" data-id="element-276">
          <MapPinIcon className="w-10 h-10 text-brand-primary mb-3" data-id="element-277" />
          <span className="text-3xl font-black mb-1" data-id="element-278">🇦🇷</span>
          <span className="text-gray-300 text-sm uppercase tracking-wider font-semibold" data-id="element-279">
            Todo el país
          </span>
        </div>
      </div>
    </section>;
}